// Angular
import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';
// service
import { AppInformationService } from '../../service/app-info.service';

@Component({
	selector: 'cv-release-notes',
	encapsulation: ViewEncapsulation.None,
	templateUrl: './release-notes.component.html',
	styleUrls: ['./release-notes.component.scss']
})
export class ReleaseNotesComponent implements OnInit {
	@Output() closeDialog: EventEmitter<any> = new EventEmitter<any>();

	public releaseNotesOf: any;

	constructor(private appInfo: AppInformationService) {}

	ngOnInit(): void {
		this.releaseNotesOf = this.appInfo.releaseNotes;
	}

	/**
	 * On Close the Dialog
	 */
	public onCloseDialog(): void {
		this.closeDialog.emit();
	}
}
